// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_PUBLICATION } from './select-publication.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_PUBLICATION);

export const selectPublicationListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectPublicationListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectPublicationListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


